import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { createStyles } from '@material-ui/core/styles';
import { Grid, Typography, Box, Chip, Select, MenuItem, Link } from '@material-ui/core/';
import { Attachment } from '@material-ui/icons';
// core components
import Button from '../../../components/CustomButtons/Button';
import Card from '../../../components/Card/Card';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';

import DefaultPerson from '../../../assets/img/person-icon.png';
import MockMap from '../../../assets/img/map-sample.png';
import MockHvac from '../../../assets/img/Hvac-sample.jpeg';
import { ActionLog, PersonImg } from './styled';

const styles = createStyles({
  cardCategoryWhite: {
    '&,& a,& a:hover,& a:focus': {
      color: 'rgba(255,255,255,.62)',
      margin: '0',
      fontSize: '14px',
      marginTop: '0',
      marginBottom: '0'
    },
    '& a,& a:hover,& a:focus': {
      color: '#FFFFFF'
    }
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: 300,
    fontFamily: '\'Roboto\', \'Helvetica\', \'Arial\', sans-serif',
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: '#777',
      fontSize: '65%',
      fontWeight: 400,
      lineHeight: 1
    }
  }
});

function IssueLogDetail(props: any) {
  const { classes } = props;
  const [issueStatus, setIssueStatus] = React.useState('inprogress');

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setIssueStatus(event.target.value as string);
  };

  return (
    <Grid container>
      <Grid item xs={9} sm={9} md={9}>
        <Card>
          <CardHeader color="primary">
            <Grid container>
              <Grid container item xs={8} alignContent="center">
                <h4 className={classes.cardTitleWhite}>Issue Log Detail</h4>
              </Grid>
              <Grid container item xs={4} justify="flex-end">
                <Button color="secondary">Report issue</Button>
              </Grid>
            </Grid>
          </CardHeader>
          <CardBody>
            <Grid container justify="center" alignContent="center" alignItems="center">
              <Grid container item xs={7}>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px" marginTop="16px">
                    <Typography variant="body2">
                      Asset ID
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px" marginTop="16px">
                    <Typography variant="body2">
                      908123
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Asset Type
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      HYAC COMPRESSOR
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Asset Model
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Copeland Scroll - Z2SDKR3D-PFJ-533
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Issue
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Noise in inlet airflow identified
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Description
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      During routine check inlet airflow has been identified as being highly noisy. Likely chance the motor is about to sieze.
                  </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Issue Tag
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Chip size="small" label="Noisy Motor" /> <Chip size="small" label="Vibration" />
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Raise by
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Lee King
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Supplier Details
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      RTC Motors & Compressors
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Issue Status
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <Select
                      value={issueStatus}
                      onChange={handleChange}
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                      <MenuItem value="none">None</MenuItem>
                      <MenuItem value="inprogress">In Progress</MenuItem>
                      <MenuItem value="done">Done</MenuItem>
                    </Select>
                  </Box>
                </Grid>
                <Grid item xs={4} sm={4} md={4}>
                  <Box marginBottom="16px">
                    <Typography variant="body2">
                      Files Attachment
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={8} sm={8} md={8}>
                  <Box marginBottom="16px">
                    <div>
                      <Link variant="body2">
                        <Attachment fontSize="inherit" /> File A
                    </Link>
                    </div>
                    <div>
                      <Link variant="body2">
                        <Attachment fontSize="inherit" /> File B
                    </Link>
                    </div>
                    <div>
                      <Link variant="body2">
                        <Attachment fontSize="inherit" /> File C
                    </Link>
                    </div>
                  </Box>
                </Grid>
              </Grid>
              <Grid container item xs={5}>
                <Box marginTop="48px" marginLeft="24px">
                  <Typography variant="subtitle1">ASSET LOCATION: <span>New York</span></Typography>
                  <img alt="map information" src={MockMap} width="100%" />
                </Box>
                <Box marginTop="24px" marginLeft="24px">
                  <img alt="hvac information" src={MockHvac} width="100%" />
                </Box>
              </Grid>
            </Grid>
          </CardBody>
        </Card>
      </Grid>
      <Grid item xs={3} sm={3} md={3}>
        <Box height="100%">
          <Card>
            <CardBody>
              <h4>History</h4>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
              <ActionLog>
                <PersonImg src={DefaultPerson} />
                <Typography variant="body2">Greg lawson update order requirement</Typography>
              </ActionLog>
            </CardBody>
          </Card>
        </Box>
      </Grid>
    </Grid >
  );
}

export default withStyles(styles)(IssueLogDetail);
